export default __webpack_public_path__ + "3187b2cb160fa8dbfed068e4c3c02673.woff2";